import { css } from '@inter-ikea-kompis/web-component';
export default class AddToBagStyle {
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			.divider {
				width: ${spacing.space50 / 16}rem;
				flex-shrink: 0;
			}

			.buyOnlineUnavailableIcon {
				display: block;
			}

			.buttonContainer {
				display: flex;
				justify-content: flex-end;
			}

			.shoppingCartUnavailableMessage {
				margin-bottom: ${spacing.space200 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=AddToBagStyle.js.map